import * as React from "react";
import { getViewportSize } from "./viewport-utils.js";
export function useViewportSize() {
  const [viewportSize, setViewportSize] = React.useState({ viewportSize: "UNKNOWN", width: 0 });
  React.useEffect(() => {
    window.addEventListener("resize", onResize);
    onResize();
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);
  function onResize() {
    setViewportSize(getViewportSize());
  }
  return viewportSize;
}
